import React from 'react';
import { useTranslation } from "react-i18next";

function DeActive() {
    var { t } = useTranslation()
    return (
        <>
            <div className="flex items-center justify-center h-full pt-16 text-center">{t("Your_profile_is_inactive")}</div>
        </>
    );
}

export default DeActive;